import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ygqtn8344d: FaireBrandEntity = {
  token: "b_ygqtn8344d",
  type: "brand",
  name: "ZWS Essentials",
  avatarUrl:
    "https://cdn.faire.com/fastly/361dcfdf9ab0fa221d973ed4c3a0041243d3554f5e4bf07c7a00302a33bd08d8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a0717e87d0a9494fcf999ea671953a54b7e38f96670b3ad8c01b0d2ec61680d1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/361dcfdf9ab0fa221d973ed4c3a0041243d3554f5e4bf07c7a00302a33bd08d8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a0717e87d0a9494fcf999ea671953a54b7e38f96670b3ad8c01b0d2ec61680d1.jpeg",
  location: "Port Saint Lucie, FL, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "Daily essentials reimagined!\n\nThe average American produces 5 lbs of trash per day. It's time to rethink the way we consume.\n\nZWS Essentials is a line of high-quality, zero waste, and plastic free products that are better for you, your home, and the planet. All of our products come in little-to-no packaging and are shipped 100% plastic-free. Everything we sell can be reused, refilled, composted, or recycled, including our shipping materials.\n\nEverything on our planet is deeply interconnected, and the environment is impacted by each one of us, and every action (and inaction) we take. Let's all work together and create sustainable, positive change by reducing our waste and being imperfect environmentalists!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:52.925Z",
    importedBy: "entity-db-cli",
  },
};
